document.addEventListener("DOMContentLoaded", function () {
  jQuery('.marquee-slide').css('display', 'block');
  jQuery('.marquee-slider').css('opacity', 1);
  if (window.jQuery && jQuery('.marquee-slider').length) {    
    jQuery('.marquee-slider').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 0,
      speed: 9000,
      cssEase: 'linear',
      infinite: true,
      arrows: false,
      dots: false,
      pauseOnHover: false,
      variableWidth: true
    });
  }
  
$('.collections-slides ul').slick({
  dots: true,
  infinite: false,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }    
  ]
});
		
$('.template-index .custom-testimonials-section ul.multicolumn-list').slick({
  dots: true,
  infinite: false,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint:575,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }    
  ]
});

if (window.jQuery && jQuery('.fcwv-slider').length) {
    jQuery('.fcwv-slider').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      infinite: true,
      autoplay: true,
      autoplaySpeed: 3000
    });
  }

  // Video Play on Click
  document.querySelectorAll('.fcwv-video-wrapper').forEach(function(wrapper){
    const cover = wrapper.querySelector('.fcwv-video-cover');
    const video = wrapper.querySelector('.fcwv-video');

    if(cover && video){
      cover.addEventListener('click', function(){
        cover.style.display = 'none';
        video.style.display = 'block';
        video.setAttribute('autoplay', 'autoplay');
        video.setAttribute('loop', 'true');
        video.play();
      });
    }
  });

  $(document).on('click', '.accordion details summary', function () {
 const $currentSummary = $(this);
 const $currentDetails = $currentSummary.closest('details');

 // Close other accordions
 $('.accordion details').not($currentDetails).each(function () {
 $(this).removeAttr('open');
 $(this).find('summary').attr('aria-expanded', 'false');
 });

 // Toggle current aria-expanded correctly
 setTimeout(function () {
 const isOpen = $currentDetails.prop('open');
 $currentSummary.attr('aria-expanded', isOpen ? 'true' : 'false');
 }, 0);
});
});
